// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__24XXz","head":"Table_head__16EJW","col":"Table_col__2ROt7"};